import {css} from "@panda/css";

import {GalleryOutlineIcon, MapIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {ITabItem, Tabs} from "@pg-design/tabs";

import {gtmOfferGalleryEvents} from "../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {insertIf} from "../../utils/insert_if";
import {OfferModalActiveTab} from "../types/OfferModalActiveTab";
import {GalleryModalTabsTitle} from "./GalleryModalTabsTitle";

interface IProps {
    modalState: OfferModalActiveTab | undefined;
    handleGalleryModalChange: (tab: OfferModalActiveTab) => void;
    hasPlanImage: boolean;
    has3dView: boolean;
}

export const GalleryModalTabs = (props: IProps) => {
    const tabs = getTabs(props.hasPlanImage, props.has3dView);

    const handleTabChange = (tab: OfferModalActiveTab) => {
        gtmOfferGalleryEvents.onGalleryTabClick(tab);
        props.handleGalleryModalChange(tab);
    };

    return (
        <Tabs value={props.modalState} className={wrapperStyle} tabs={tabs} onChange={handleTabChange} variant="line" activeColor="invert-dark" color="gray" />
    );
};

const getTabs: (hasPlanImage: boolean, has3dView: boolean) => ITabItem<OfferModalActiveTab>[] = (hasPlanImage, has3dView) => [
    {
        title: <GalleryModalTabsTitle icon={GalleryOutlineIcon} label="Galeria" />,
        value: OfferModalActiveTab.GALLERY
    },
    {
        title: <GalleryModalTabsTitle icon={GalleryOutlineIcon} label={has3dView ? "Zdjęcia z budowy (3D)" : "Zdjęcia z budowy"} />,
        value: OfferModalActiveTab.CONSTRUCTION_GALLERY
    },
    ...insertIf(hasPlanImage, {
        title: <GalleryModalTabsTitle icon={PropertyPlanIcon} label="Rzut" />,
        value: OfferModalActiveTab.PLAN
    }),
    {
        title: <GalleryModalTabsTitle icon={MapIcon} label="Okolica" />,
        value: OfferModalActiveTab.MAP
    }
];

const wrapperStyle = css({
    overflowX: "hidden",
    width: "100%",

    "& div": {
        display: "flex",
        justifyContent: "center"
    },

    sm: {
        "& div": {
            justifyContent: "flex-start"
        }
    }
});
import {css} from "@panda/css";

import {GalleryOutlineIcon, MapIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {ITabItem, Tabs} from "@pg-design/tabs";

import {gtmOfferGalleryEvents} from "../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {insertIf} from "../../utils/insert_if";
import {OfferModalActiveTab} from "../types/OfferModalActiveTab";
import {GalleryModalTabsTitle} from "./GalleryModalTabsTitle";

interface IProps {
    modalState: OfferModalActiveTab | undefined;
    handleGalleryModalChange: (tab: OfferModalActiveTab) => void;
    hasPlanImage: boolean;
    has3dView: boolean;
}

export const GalleryModalTabs = (props: IProps) => {
    const tabs = getTabs(props.hasPlanImage, props.has3dView);

    const handleTabChange = (tab: OfferModalActiveTab) => {
        gtmOfferGalleryEvents.onGalleryTabClick(tab);
        props.handleGalleryModalChange(tab);
    };

    return (
        <Tabs value={props.modalState} className={wrapperStyle} tabs={tabs} onChange={handleTabChange} variant="line" activeColor="invert-dark" color="gray" />
    );
};

const getTabs: (hasPlanImage: boolean, has3dView: boolean) => ITabItem<OfferModalActiveTab>[] = (hasPlanImage, has3dView) => [
    {
        title: <GalleryModalTabsTitle icon={GalleryOutlineIcon} label="Galeria" />,
        value: OfferModalActiveTab.GALLERY
    },
    {
        title: <GalleryModalTabsTitle icon={GalleryOutlineIcon} label={has3dView ? "Zdjęcia z budowy (3D)" : "Zdjęcia z budowy"} />,
        value: OfferModalActiveTab.CONSTRUCTION_GALLERY
    },
    ...insertIf(hasPlanImage, {
        title: <GalleryModalTabsTitle icon={PropertyPlanIcon} label="Rzut" />,
        value: OfferModalActiveTab.PLAN
    }),
    {
        title: <GalleryModalTabsTitle icon={MapIcon} label="Okolica" />,
        value: OfferModalActiveTab.MAP
    }
];

const wrapperStyle = css({
    overflowX: "hidden",
    width: "100%",

    "& div": {
        display: "flex",
        justifyContent: "center"
    },

    sm: {
        "& div": {
            justifyContent: "flex-start"
        }
    }
});
